import 'components/shortlist/actions/save/index.css'
import { Theme } from '@radix-ui/themes'
import * as React from 'react'
import Modal from 'react-modal'
import { Box } from 'components/ds'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import modalStyles from 'components/utils/modalStyles'
import DialogIcon from './dialog-icon'

const ModalActionDialog = ({
  type,
  header,
  children,
  onClose,
  onSubmit,
  onSecondaryClick,
  submitButtonCaption,
  secondaryButtonCaption,
}: {
  type: 'success' | 'error'
  header: string
  children: React.ReactNode
  onClose: () => unknown
  onSubmit: () => unknown
  onSecondaryClick?: () => unknown
  secondaryButtonCaption?: string
  submitButtonCaption: string
}): React.ReactNode => {
  return (
    <Modal onRequestClose={onClose} isOpen style={modalStyles}>
      <Theme>
        <div className="Form FormCentered">
          <div>
            <DialogIcon type={type} />
          </div>
          <h1 className="Form_Header no-margin-bottom">{header}</h1>
          <Box mb="4">{children}</Box>
          <div className="Form_ButtonsContainer separated-medium">
            <ButtonContainer>
              {secondaryButtonCaption ? (
                <Button
                  onClick={onSecondaryClick}
                  caption={secondaryButtonCaption}
                />
              ) : null}
              <Button
                appearance="primary"
                onClick={onSubmit}
                caption={submitButtonCaption}
              />
            </ButtonContainer>
          </div>
        </div>
      </Theme>
    </Modal>
  )
}

export default ModalActionDialog
